import { z } from "zod";

import { multiSelectResponseSchema } from "@components/PatientForms/common/schemaHelper";

import { FormField } from "../../../FormEngine/types";

/**
 * Medication Feedback form schema
 *
 * This schema defines the fields for the Medication Feedback form
 * using the FormEngine component.
 */
export const medicationFeedbackSchema: FormField[] = [
  {
    type: "textarea",
    name: "medicationFeedback",
    title: "Medications Since Last Visit",
    description: "Since last visit, how are things going on your medicine?",
    fieldProps: {
      sx: { mt: 0 },
    },
  },
  {
    type: "multi-select-response",
    name: "medicationSymptoms",
    title: "Side Effects",
    description: "Please describe any side effects with your medications that you are concerned about.",
    options: [
      "Nausea",
      "Vomiting",
      "Constipation",
      "Diarrhea",
      "Abdominal Pain",
      "Heartburn",
      "Redness and/or swelling at injection site",
      "Rashes",
      "Hair loss",
      "Fatigue",
      "Headache",
      "Dizziness",
      "Lump in throat or neck",
      "Other",
    ].map((option) => ({ value: option, label: option })),
    schema: [
      {
        type: "input",
        name: "description",
        label: "Please describe",
      },
    ],
    fieldProps: {
      includeNoneOption: true,
    },
    rule: z
      .array(multiSelectResponseSchema)
      .min(1, { message: "Please select at least one option" }),
  },
];

export default medicationFeedbackSchema;
